import {Player, UserSource} from "@/store/player/types";
import {SuperPackPanel} from "@/scenes.ui/super-pack-panel";
import {TaskOption} from "@/store/chain/types";
import {ChainItemType} from "@/model/chain-item-type";
import SpriteUtils from "@/utils/sprite-utils";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Tr} from "@/i18n/i18n";
import {SquareButton} from "@/scenes.ui/square-button";
import Sprite = Phaser.GameObjects.Sprite;
import {ChainPackPanel} from "@/scenes.ui/chain-pack-panel";
import {BankOption} from "@/store/shop/types";
import AtlasUtils from "@/utils/atlas-utils";
import Text = Phaser.GameObjects.Text;

export class ChainTaskPanel extends ChainPackPanel {

    private innerBar!: Sprite;

    constructor(scene: Phaser.Scene, x: number, y: number, bo: TaskOption, player: Player, userSource: UserSource,
                buyCallback: () => void, heroDescCallback: (heroId: string) => void, chainItemType: ChainItemType, currIndex: number, isReward: boolean = false,
                productPriceView: string | undefined = undefined) {
        super(scene, x, y, bo, player, userSource, buyCallback, heroDescCallback, chainItemType, currIndex, isReward, productPriceView);
    }

    protected initialize(bankOption: BankOption) {
        let INNER_BAR_WIDTH: number = 293;
        let bo = bankOption as TaskOption;
        let outerBar = SpriteUtils.addSprite(this.scene, ChainTaskPanel.TITLE_X + 2, 99, Keys.ATLAS_CHAIN, 'progr_out').setOrigin(0, 0);

        this.innerBar = SpriteUtils.addSprite(this.scene, ChainTaskPanel.TITLE_X + 6, 101, Keys.ATLAS_CHAIN, 'progr_in')
            .setOrigin(0, 0);
        SpriteUtils.setDispSize(this.innerBar, INNER_BAR_WIDTH * (bo.countCurr / bo.countTotal) * CU.S, 16 * CU.S);

        let rewText = TextUtils.addTextAdvanced(this.scene, Tr('nagrada') + ':', SuperPackPanel.TITLE_X + 5, 142,
            '#ffe9a9', 12, 'normal', 450, 'left', 2, Fonts.BENGALY_NORMAL);
        rewText.setStroke('#8c4f19', 5);

        let shadow = SpriteUtils.addSprite(this.scene, 66, 165, Keys.PLACE_SHADOW);

        this.add([this.innerBar, outerBar, rewText, shadow]);

        let image = undefined;
        if (bo.atlasId === 'creature') {
            let image1 = SpriteUtils.addSprite(this.scene, 65, 110, 'sword1');
            let image2 = SpriteUtils.addSprite(this.scene, 65, 150, AtlasUtils.getCreatureRoadAtlas(bo.imageId) , bo.imageId);
            this.add([image1, image2]);
        } else if (!bo.atlasId) {
            image = SpriteUtils.addSprite(this.scene, 64, 110, bo.imageId);
            SpriteUtils.scale(image, ChainTaskPanel.getAtlasScale(bo.imageId));
            this.add(image);
        } else {
            if (!!bo.atlasId) {
                image = SpriteUtils.addSprite(this.scene, 66, 100, bo.atlasId, bo.imageId);
            } else {
                image = SpriteUtils.addSprite(this.scene, 66, 100, bo.imageId);
            }
            this.add(image);
        }

        if (bo.countCurr < bo.countTotal) {
            let progr = TextUtils.addTextAdvanced(this.scene, String(bo.countCurr) + '/' + String(bo.countTotal), outerBar.x / CU.S + INNER_BAR_WIDTH / 2, outerBar.y / CU.S + 11,
                '#e3f5e0', 9, 'bold', 450, 'center', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);
            progr.setStroke('#505050', 3);
            this.add(progr);
        } else {
            let progr = TextUtils.addTextAdvanced(this.scene, Tr('compl'), outerBar.x / CU.S + INNER_BAR_WIDTH / 2, outerBar.y / CU.S + 11,
                '#17ff16', 11, 'normal', 450, 'center', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);
            progr.setStroke('#505050', 3);
            this.add(progr);
        }

        let ind = 0;
        for (let pi of this.purchaseItems) {
            SpriteUtils.scale(pi, 0.7 / CU.S / CU.S, 0.7 / CU.S / CU.S);
            pi.x += (78 - ind * 30) * CU.S;
            pi.y += 10 * CU.S;
            ++ind;
        }
    }

    protected getDescPosX(bo: BankOption): number {
        return ChainTaskPanel.TITLE_X + 4;
    }

    protected getDescPosY(bo: BankOption): number {
        return 55;
    }

    protected getDescWidth(bo: BankOption): number {
        return 310;
    }

    protected getDescFontSize(): number {
        return 11;
    }

    protected buyButtonVisible(bo: BankOption): boolean {
        let to = bo as TaskOption;
        return to.countCurr >= to.countTotal;
    }

    protected priceVisible(bo: BankOption): boolean {
        return false;
    }

    protected setBuyCallback(buyButton: SquareButton, callback: () => unknown): void {
        buyButton.setCallback(() => {
            callback();
        });
    }

    private static getAtlasScale(imageId: string) {
        if (imageId === 'victory_knight') {
            return 0.36;
        }
        return 1.0;
    }
}
